import { HttpParams } from '@angular/common/http';

export class HttpFormParams extends HttpParams {
  constructor(options?: any) {
    if (options && options.encoder) {
      super(options);
      return;
    }
    if (!options) {
      options = {};
    }
    options.encoder = {
      decodeKey(key: string): string {
        return decodeURIComponent(key);
      },
      decodeValue(value: string): string {
        return decodeURIComponent(value);
      },
      encodeKey(key: string): string {
        return encodeURIComponent(key);
      },
      encodeValue(value: string): string {
        return encodeURIComponent(value);
      },
    };
    super(options);
  }

  /*Array not provided*/
  static settingByKeys(object): HttpFormParams {
    return Object.keys(object).reduce((result, key) => {
      if (object[key] === undefined && !!object[key]) {
        return result;
      }
      return result.set(key, this.isObject(object[key]) ? JSON.stringify(object[key]) : object[key]);
    }, new HttpFormParams());
  }

  private static isObject(value) {
    return value.constructor.toString().includes('Object');
  }
}
